/* tslint:disable */

declare var Object: any;
export interface ERPsalesDCNoteInterface {
  "id"?: number;
}

export class ERPsalesDCNote implements ERPsalesDCNoteInterface {
  "id": number;
  constructor(data?: ERPsalesDCNoteInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPsalesDCNote`.
   */
  public static getModelName() {
    return "ERPsalesDCNote";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPsalesDCNote for dynamic purposes.
  **/
  public static factory(data: ERPsalesDCNoteInterface): ERPsalesDCNote{
    return new ERPsalesDCNote(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPsalesDCNote',
      plural: 'ERPsalesDCNotes',
      path: 'ERPsalesDCNotes',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPsalesDCNote.ts